import Decimal from 'decimal.js-light';
export default {
    computed: {
        // 海外用户标志
        $overseasType() {
            return this.$store.state.Login.loginData.overseasType;
        },
        // 当前用户币种
        $currencyType() {
            return this.$store.state.Login.loginData.currencyType;
        },
    },
    methods: {
        // 弹出登录框
        $showLogin() {
            this.$store.commit('Login/loginIsShow', true);
        },
        // 退出登录
        $logout() {
            this.$ajax({
                url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                data: {
                    act: 'postUserSignOutData',
                },
                success: () => {
                    // 清空cookie
                    localStorage.removeItem('btnactive');
                    this.$setCookie('cookieName', '', 0);
                    this.$setCookie('cookiePwd', '', 0);
                    // this.$ysf('logoff');
                    if (location.origin.includes('https://intl.3j-mall.com') || !this.$isZh()) {
                        window.top.location.href = '/ImportHome';
                    } else {
                        window.top.location.href = '/';
                    }
                   
                }
            });
        },
        // 查询登录状态
        $isLogin() {
            return new Promise((resolve) => {
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'getLoginTypeData',
                    },
                    success: (res) => {
                        const userInfo = {
                            loginType: res.success.loginType === '1',// 登录状态
                            headPortrait: res.success.headPortrait,// 用户头像URL
                            userType: res.success.userType,// 用户分类
                            username: res.success.username,// 用户名
                            nickname: res.success.nickname,// 用户昵称
                            // 通过用户分类判断国内还是海外 海外用户标志 true-非中国大陆、false-中国大陆
                            overseasType: ['5'].includes(res.success.userType),
                            currencyType: res.success.currencyType || 'CNY',// 海外用户币制 CNY-人民币 USD-美金、EUR-欧元
                            isFirstCert: res.success.isFirstCert,// 是否第一次申请协议认证 0-第一次、1-不是第一次
                            companyName: res.success.companyName,// 公司名称
                            mobile: res.success.mobile,// 手机号（不加密）
                            email: res.success.email,
                            interested: res.success.interested,// 是否选过感兴趣的信息 0-N、1-Y
                            exportPayMethod: res.success.exportPayMethod,// 出口结算方式 0-付买、1-月结
                            exportAccount: res.success.exportAccount,// 出口账户 0-N、1-Y
                            importAccount: res.success.importAccount,// 进口账户 0-N、1-Y
                            exportMain: res.success.exportMain,// 出口主账户 0-N、1-Y
                            importMain: res.success.importMain,// 进口主账户 0-N、1-Y
                            completeRegisterType: res.success.completeRegisterType
                        };
                        // 存入用户信息
                        this.$store.commit('Login/loginData', userInfo);
                        // 登录状态已返回
                        this.$store.commit('Login/loginAjaxComplete', true);
                        resolve(userInfo);
                        this.$customerServiceQQ();// 查询客服QQ号
                        if (res.success.loginType === '1') {
                            // this.$getIntegralTypeData();// 获取用户签到状态
                            this.$shoppingCart();// 登录后查询购物车数量
                        }
                    }
                });
            });
        },
        // 查询客服QQ号
        $customerServiceQQ() {
            // 客服QQ
            this.$ajax({
                url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                data: {
                    act: 'getCustomerServiceQQ',
                },
                success: (res) => {
                    let loginStatus = res.success.loginStatus;// 是否登录 0-N、1-Y
                    let qq = res.success.customerService.exportQQ;// 客服QQ
                    let staffid = res.success.customerService.staffid;// 网易七鱼在线客服ID
                    let importQQ = res.success.customerService.importQQ;// 进口客服QQ
                    // 判断是否已经缓存客服QQ
                    if (sessionStorage.customerService) {
                        let session = JSON.parse(sessionStorage.customerService);
                        // 当前登录状态已更新
                        if (session.loginStatus !== loginStatus) {
                            sessionStorage.customerService = JSON.stringify({
                                qq: qq,
                                importQQ: importQQ,
                                staffid: staffid,
                                loginStatus: loginStatus
                            });
                        }
                    } else {
                        sessionStorage.customerService = JSON.stringify({
                            qq: qq,
                            importQQ: importQQ,
                            staffid: staffid,
                            loginStatus: loginStatus
                        });
                    }
                    let session = JSON.parse(sessionStorage.customerService);
                    this.$store.commit('customerServiceQQ', session.qq);
                    this.$store.commit('importCustomerServiceQQ', session.importQQ);
                    this.$store.commit('customerServiceStaffid', session.staffid);
                    if (res.success.customerService.exportEmail) {
                        this.$store.commit('customerServiceEmail', res.success.customerService.exportEmail);
                    }
                    if (res.success.customerService.importEmail) {
                        this.$store.commit('importEmailCustomerServiceEmail', res.success.customerService.importEmail);
                    }
                }
            });
        },
        // 查询购物车数量
        $shoppingCart() {
            // 购物车
            // this.$ajax({
            //    url: '/ProductsCenterHandler/ProductsCart/ProductsCartHandler.ashx',
            //    data: {
            //        act: 'getProductCartValidData',
            //    },
            //    success: (res) => {
            //        this.$store.commit('shoppingCart', res.success.validCartTotal);
            //    }
            // });
        },
        // 获取用户签到状态
        // $getIntegralTypeData() {
        //    this.$ajax({
        //        url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
        //        data: {
        //            act: 'getIntegralTypeData'// 获取签到送积分签到状态
        //        },
        //        success: (res) => {
        //            this.$store.commit('integralType', res.success.integralType);
        //        }
        //    });
        // },
        // 处理单价格式
        $handlerPrice(price) {
            return price === '' ? '--.--' : price;
        },
        /**
         * 普通弹窗
         * @param msg
         * @param callback
         * @param dangerouslyUseHTMLString
         * @param showConfirmButton
         * @param showClose
         * @param confirmButtonText
         * @param type
         * @param title
         */
        $Alert(
            {
                msg = '',
                callback = () => {
                },
                dangerouslyUseHTMLString = false,
                showConfirmButton = true,
                showClose = true,
                confirmButtonText = this.$t('message.confirm'),
                type = 'info',
                title = this.$t('message.tip')
            }
        ) {
            this.$alert(msg, title, {
                type: type,
                dangerouslyUseHTMLString: dangerouslyUseHTMLString,
                showConfirmButton: showConfirmButton,
                showClose: showClose,
                confirmButtonText: confirmButtonText,
                callback: () => {
                    setTimeout(() => {
                        callback();
                    }, 320);
                }
            });
        },
        /**
         * 确认消息弹窗
         * @param msg 确认消息内容
         * @param callback 确认回调
         * @param cancel 取消回调
         * @param close 关闭回调
         * @param showConfirmButton
         * @param showCancelButton
         * @param showClose 显示关闭按钮
         * @param beforeClose 关闭前的回调
         * @param center 是否居中布局
         * @param distinguishCancelAndClose 分离取消和关闭
         * @param dangerouslyUseHTMLString 支持html结构
         * @param closeOnClickModal 点击遮罩关闭
         * @param closeOnPressEscape 点击esc关闭
         * @param type 图标样式
         * @param title 标题
         * @param confirmButtonText 确认文字
         * @param cancelButtonText 取消文字
         */
        $Confirm(
            {
                msg = '',
                callback = () => {
                },
                cancel = () => {
                },
                close = () => {
                },
                showConfirmButton = true,
                showCancelButton = true,
                showClose = true,
                beforeClose = null,
                center = false,
                distinguishCancelAndClose = false,
                dangerouslyUseHTMLString = false,
                closeOnClickModal = true,
                closeOnPressEscape = true,
                type = 'warning',
                title = this.$t('message.tip'),
                confirmButtonText = this.$t('message.confirm'),
                cancelButtonText = this.$t('message.cancel')
            }
        ) {
            this.$confirm(msg, title, {
                type: type,
                center: center,
                showClose: showClose,
                showConfirmButton: showConfirmButton,
                showCancelButton: showCancelButton,
                distinguishCancelAndClose: distinguishCancelAndClose,
                dangerouslyUseHTMLString: dangerouslyUseHTMLString,
                closeOnClickModal: closeOnClickModal,
                closeOnPressEscape: closeOnPressEscape,
                confirmButtonText: confirmButtonText,
                cancelButtonText: cancelButtonText,
                beforeClose: (action, instance, done) => {
                    if (beforeClose) {
                        setTimeout(() => {
                            beforeClose(action, instance, done);
                        }, 320);
                    } else {
                        done();
                    }
                }
            }).then(() => {
                setTimeout(() => {
                    callback();
                }, 320);
            }).catch((action) => {
                setTimeout(() => {
                    if (action === 'cancel') {
                        cancel();
                    } else if (action === 'close') {
                        close();
                    }
                }, 320);
            });
        },
        $ConfirmM({
                      title = '提示',
                      msg = '',
                      callback = () => {
                      },
                      cancel = () => {
                      }
                  }) {
            this.$dialog.confirm({
                title: title,
                message: msg,
                showCancelButton: true,
            }).then(() => {
                setTimeout(() => {
                    callback();
                }, 320);
            }).catch((action) => {
                setTimeout(() => {
                    if (action === 'cancel') {
                        cancel();
                    } else if (action === 'close') {
                        close();
                    }
                }, 320);
            });
        },
        /**
         * 消息提示
         * @param msg 消息文字
         * @param type 主题
         * @param dangerouslyUseHTMLString 作为 HTML 片段处理
         * @param showClose 是否显示关闭按钮
         * @param duration 显示时长
         */
        $Message(
            {
                msg = '',
                type = 'warning',
                dangerouslyUseHTMLString = false,
                showClose = true,
                duration = 3000
            }
        ) {
            this.$message({
                message: msg,
                type: type,
                dangerouslyUseHTMLString: dangerouslyUseHTMLString,
                showClose: showClose,
                duration: duration
            });
        },
        /**
         * pc or 移动端 弹起QQ客服会话
         * @param qq
         * @returns {string}
         */
        $pcOrMobileQQ(qq = '') {
            if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
                // 如果是PC端
                return `tencent://message/?uin=${qq}&Menu=yes`;
            } else {
                // 如果是移动端
                return `mqqwpa://im/chat?chat_type=wpa&uin=${qq}&version=1&src_type=web`;
            }
        },
        /**
         * 换一换
         * @param unused 未使用
         * @param isUsing 正在使用
         * @param used 已使用
         * @param num 每次展示个数
         */
        $nextBatch(unused = [], isUsing = [], used = [], num = 1) {
            // 如果个数不够 全部内容返回到正在使用
            if (unused.length + isUsing.length + used.length <= Number(num)) {
                return {unused: [], isUsing: [...isUsing, ...unused, ...used], used: []};
            }
            // 将正在使用的转为已使用的并置空正在使用
            used = [...used, ...isUsing];
            isUsing = [];
            for (let i = 0; i < Number(num); i++) {
                if (unused.length === 0) {
                    // 如果未使用已用完，将已使用转入未使用
                    Object.assign(unused, used);
                    used = [];
                }
                // 取出的随机内容的下标
                const tempIndex = this.$getRand(0, unused.length);
                isUsing.push(unused[tempIndex]);
                unused.splice(tempIndex, 1);
            }
            return {unused, isUsing, used};
        },
        // 市场推广
        $marketingPropaganda() {
            const marketing = this.$getQueryString('marketing');
            if (marketing) {
                this.$bigData('marketingPropaganda', 'marketingPropaganda', marketing);
            }
        },
        // 邮件联系我们
        $emailContactUs({email = '', qs = null}) {
            if (!email) {
                this.$Alert({
                    msg: this.$t('message.emailNotFound')
                });
                return;
            }
            const vNode = this.$createElement;
            this.$Alert({
                showConfirmButton: false,
                title: this.$t('message.hotLine'),
                type: '',
                msg: vNode(
                    'div', {
                        style: 'width:100%;text-align: center;overflow: hidden;'
                    }, [
                        vNode('el-tooltip', {
                            props: {
                                placement: 'top',
                                content: email,
                            }
                        }, [
                            vNode('span', {
                                style: 'display: inline-block;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;',
                            }, this.$t('message.userEmail') + email),
                        ]),
                        vNode('div', {
                            style: 'text-align:center;margin-top: 10px',
                        }, [
                            vNode('el-button', {
                                attrs: {
                                    type: 'primary'
                                },
                                on: {
                                    click: () => {
                                        this.$clipboard.writeText(email);
                                        this.$Message({
                                            msg: this.$t('message.copiedEmail'),
                                            type: 'success'
                                        });
                                    }
                                },
                            }, this.$t('message.copyEmail')),
                            vNode('a', {
                                attrs: {
                                    href: `mailto:${email}?${this.$qs.stringify(qs)}`,
                                    target: '_blank'
                                },
                                style: 'margin-left: 10px;'
                            }, [
                                vNode('el-tooltip', {
                                    props: {
                                        content: this.$t('message.installEmail'),
                                    }
                                }, [
                                    vNode('el-button', {
                                        attrs: {
                                            type: 'primary'
                                        },
                                    }, this.$t('message.startEmail'))
                                ]),
                            ]),
                        ]),
                    ]
                )
            });
        },
        // 个人中心刷新当前子组件
        $centerReload() {
            this.$router.replace(location.pathname + location.search);
        },
        // 获取当前查看的币种
        $getNowCurrency() {
            return this.$getCookie('currency') || 'CNY';
        },
        /**
         * 网易七鱼客服
         */
        // $ysfOpen(
        //    {
        //        staffid = '',// 客服ID 管理员：3926148
        //        bookingInfo = null,// 订单信息
        //        productInfo = null,// 产品信息
        //    }
        // ) {
        //    if (!this.$store.state.ysfOnReady) {
        //        this.$Message({
        //            msg: '客服正在飞速赶来，请再试一次~'
        //        });
        //        return;
        //    }
        //    let config = {
        //        success: () => {
        //            (async () => {
        //                // 如有订单信息传入订单信息
        //                if (bookingInfo) {
        //                    // 网易客服 发送订单信息
        //                    //await this.$ysfBooking(bookingInfo);
        //                }
        //                // 如有产品信息传入产品信息
        //                if (productInfo) {
        //                    // 网易客服 发送产品信息
        //                    //await this.$ysfProduct(productInfo);
        //                }
        //                //this.$ysf('open');
        //            })();
        //        },
        //        error: () => {
        //            this.$Message({
        //                msg: '因网络不稳定，在线客服系统加载失败~'
        //            });
        //        },
        //    };
        //    if (this.$store.state.Login.loginData.loginType) {
        //        if (this.$prodOrDev()) {
        //            // 当前登录用户标识，不传表示匿名用户
        //            config.uid = this.$store.state.Login.loginData.username;
        //            // 当前登录用户名称
        //            config.name = this.$store.state.Login.loginData.username;
        //        } else {
        //            // 当前登录用户标识，不传表示匿名用户
        //            config.uid = this.$store.state.Login.loginData.username + '（平台测试）';
        //            // 当前登录用户名称
        //            config.name = this.$store.state.Login.loginData.username + '（平台测试）';
        //        }
        //        // 用户手机号
        //        config.mobile = this.$store.state.Login.loginData.mobile;
        //        // 扩展信息
        //        config.data = JSON.stringify([
        //            {
        //                index: 0,
        //                key: 'companyName',
        //                label: '所属公司',
        //                value: this.$store.state.Login.loginData.companyName
        //            },
        //        ]);
        //    }
        //    // 如果传了客服ID
        //    if (staffid) {
        //        config.staffid = staffid;
        //    }
        //    //this.$ysf('onready', () => {
        //    //    this.$ysf('config', config);
        //    //});
        // },
        /**
         * 网易客服 发送订单信息
         */
        // $ysfBooking(
        //    {
        //        productNo = '',// 产品编号
        //        productName = '',// 产品名称
        //        orderBillCode = '',// 托单号
        //        drCode = '',// 主提单号
        //        bookingPosition = '',// 正备装 0-正装、1-备装
        //    }
        // ) {
        //    if (bookingPosition) {
        //        bookingPosition = bookingPosition === '0' ? '正装' : '备装';
        //    }
        //    return new Promise((resolve) => {
        //
        //        // 订单信息
        //        const bookingInfo = {
        //            productNo: productNo,
        //            productName: productName,
        //            orderBillCode: orderBillCode,
        //            drCode: drCode,
        //            bookingPosition: bookingPosition,
        //        };
        //
        //        this.$ysf('onready', () => {
        //            this.$ysf('product', {
        //                show: 1,// 1为打开，其他参数为隐藏（包括非零元素）
        //                sendByUser: 0,// 是否由访客手动发送，1为是，其他参数为否
        //                title: productName,
        //                desc: orderBillCode + ',' + drCode,
        //                picture: 'https://www.3j-mall.com/staticResource/img/general/sjm_logo.png',
        //                note: bookingPosition,
        //                url: 'https://www.3j-mall.com/product/SmartProducts?productNo=' + productNo,
        //                tags: [{
        //                    label: '打开订单详情',// 按钮名字
        //                    url: 'https://www.3j-mall.com/info/BookingInfo?bookingInfo=' + encodeURIComponent(this.$Base64.encode(JSON.stringify(bookingInfo))),// 非必填，如果没有focusIframe字段，或者没有匹配到iframe，就以新窗口打开这个链接
        //                }],
        //                success: () => {
        //                    resolve();
        //                },
        //                error: () => {
        //                    this.$Message({
        //                        msg: '因网络不稳定，在线客服系统加载失败~'
        //                    });
        //                },
        //            });
        //        });
        //    });
        // },
        /**
         * 网易客服 发送产品信息
         */
        // $ysfProduct(
        //    {
        //        productNo = '',// 产品编号
        //        productName = '',// 产品名称
        //        bookingPosition = '',// 正备装 0-正装、1-备装
        //        packageWay = '',// 0-散货、1-托盘
        //        pieces = '',// 件数
        //        weight = '',// 重量
        //        volume = '',// 体积
        //        startPort = '',// 始发港
        //        destination = '',// 目的港
        //        productDate = '',// 开航日期
        //    }
        // ) {
        //    if (bookingPosition) {
        //        bookingPosition = bookingPosition === '0' ? '正装' : '备装';
        //    }
        //    if (packageWay) {
        //        packageWay = packageWay === '0' ? '散货' : '托盘';
        //    }
        //    return new Promise((resolve) => {
        //        this.$ysf('onready', () => {
        //            this.$ysf('product', {
        //                show: 1,// 1为打开，其他参数为隐藏（包括非零元素）
        //                sendByUser: 0,// 是否由访客手动发送，1为是，其他参数为否
        //                title: '我正在看：' + productName,
        //                desc: `始发港：${startPort};目的港：${destination};开航日期：${productDate};`,// 描述
        //                picture: 'https://www.3j-mall.com/staticResource/img/general/sjm_logo.png',
        //                note: `件重体：${pieces}/${weight}/${volume};${bookingPosition};${packageWay}`,// 备注
        //                url: 'https://www.3j-mall.com/product/SmartProducts?productNo=' + productNo,
        //                success: () => {
        //                    resolve();
        //                },
        //                error: () => {
        //                    this.$Message({
        //                        msg: '因网络不稳定，在线客服系统加载失败~'
        //                    });
        //                },
        //            });
        //        });
        //    });
        // },
        /**
         * 货型转换方法
         * @param cargoType
         */
        $cargoType(cargoType = '') {
            return {
                0: this.$t('message.bulk'),
                1: this.$t('message.tray')
            }[cargoType] || cargoType;
        },
        /**
         * 生产or测试
         * @returns {boolean} true生产、false测试
         */
        $prodOrDev() {
            return ['3j-mall.com', 'www.3j-mall.com'].includes(window.location.hostname.toLowerCase());
        },
        /**
         * 获取物流圈地址
         * @returns {string}
         */
        $getSupplierUrl() {
            return this.$prodOrDev() ? 'https://supplier.3j-mall.com' : 'http://supplier-test.3j-mall.com:92';
        },
        /* ************************************移动端************************************ */
        /**
         * 移动端 alert
         * @param title
         * @param msg
         * @param callback
         */
        $AlertM(
            {
                title = '提示',
                msg = '',
                callback = () => {
                },
            }
        ) {
            this.$dialog({
                title: title,
                message: msg,
                beforeClose: (action, done) => {
                    callback();
                    done();
                }
            });
        },
        /**
         * 渲染头像url
         * @param url
         * @returns {string}
         */
        $avatarUrl: (url = '') => {
            if (!url) {
                return '/staticResource/img/headPortrait/default.png';
            }
            // 本地头像列表
            const localAvatarList = ['1.png', '2.png', '3.png', '4.png', '5.png', '6.png', '7.png', '8.png', '9.png', '10.png', 'default.png'];
            if (localAvatarList.includes(url)) {
                return '/staticResource/img/headPortrait/' + url;
            } else {
                return url;
            }
        },
        /**
         * 倒计时计算
         * @param millisecond 毫秒
         * @param type 0-秒、1-秒分、2-秒分时、3-秒分时天
         * @returns {{minute: number, second: number}|{hour: number, minute: number, second: number}|{hour: number, day: number, minute: number, second: number}|{second: number}}
         */
        $countdown: (millisecond = '0', type = '0') => {
            millisecond = Number(millisecond);
            switch (type) {
                case '0': {// 秒
                    const second = Math.floor(millisecond / 1000);
                    return {second};
                }
                case '1': {// 秒分
                    millisecond = millisecond / 1000;
                    // 分钟
                    const minute = Math.floor(millisecond / 60);
                    // 秒
                    const second = Math.floor(millisecond % 3600 % 60);
                    return {minute, second};
                }
                case '2': {// 秒分时
                    millisecond = millisecond / 1000;
                    // 小时
                    const hour = Math.floor(millisecond / 3600);
                    // 分钟
                    const minute = Math.floor(millisecond % 3600 / 60);
                    // 秒
                    const second = Math.floor(millisecond % 3600 % 60);
                    return {hour, minute, second};
                }
                case '3': {// 秒分时天
                    millisecond = millisecond / 1000;
                    // 天
                    const day = Math.floor(millisecond / 86400);
                    // 小时
                    const hour = Math.floor(millisecond % 86400 / 3600);
                    // 分钟
                    const minute = Math.floor(millisecond % 3600 / 60);
                    // 秒
                    const second = Math.floor(millisecond % 3600 % 60);
                    return {day, hour, minute, second};
                }
            }
        },
        /**
         * 合计金额计算
         * @param costList 金额数组
         * @returns {string}
         */
        $realCost: (costList = []) => {
            if (costList.length === 0) {
                return '0.00';
            }
            
            let total = Decimal(0);
            costList.forEach(item => {
                total = total.add(Number(item));
            });
            return total.toFixed(2);
        },
 
    }
};
